<h2 mat-dialog-title class="mat-dialog-title-offset">Generate Learner Access@if (studentName != null && studentName != '') {
  <div class="tw:inline"> - ({{studentName}})</div>
}</h2>

<div class="modal-close-icon-container tw:flex tw:items-center">
  <button class="close-modal" mat-button [mat-dialog-close]="false" tabindex='-1'>
    <div class="close-modal modal-close-icon">
    </div>
  </button>
</div>

<mat-dialog-content class="mat-typography modal-master-container tw:mx-2">
  <div class="tw:w-full tw:p-4 tw:m-0 tw:mt-2 content-container">
    <!-- Single reusable widget — the modal is just the dialog chrome around it (bug 37289). -->
    <generate-student-access
      [studentId]="studentId"
      [studentName]="studentName"
      [showHeader]="false"
      [showWebsiteLinkButton]="showWebsiteLink"
      [showSignUpEmailButton]="showSignUpEmail">
    </generate-student-access>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="div-flex-buttons">
  <div class="tw:flex tw:flex-wrap tw:p-0 tw:m-0 tw:w-full">
    <div class="tw:w-full tw:p-0 tw:m-0">
      <button mat-button [mat-dialog-close]="false" class="btn btn-primary btn-sm tw:my-1 tw:mx-1 divclose tw:float-left">Close</button>
    </div>
  </div>
</mat-dialog-actions>
